module.exports = __webpack_public_path__ + "static/img/logoBottom.f150be9e.png";